export const formatPhone = (value) => {
  if (!value) return '';
  const numbers = String(value).replace(/\D/g, '');
  if (!numbers) return '';
  
  if (numbers.length <= 2) {
    return `+${numbers}`;
  } else if (numbers.length <= 4) {
    return `+${numbers.slice(0, 2)} (${numbers.slice(2)}`;
  } else if (numbers.length <= 12) {
    if (numbers.length <= 8) {
      return `+${numbers.slice(0, 2)} (${numbers.slice(2, 4)}) ${numbers.slice(4)}`;
    } else {
      return `+${numbers.slice(0, 2)} (${numbers.slice(2, 4)}) ${numbers.slice(4, 8)}-${numbers.slice(8)}`;
    }
  } else {
    // Para números com 13 ou mais dígitos (5 dígitos na primeira parte e 4 na segunda)
    return `+${numbers.slice(0, 2)} (${numbers.slice(2, 4)}) ${numbers.slice(4, 9)}-${numbers.slice(9, 13)}`;
  }
};
